module.exports = __webpack_public_path__ + "static/media/paint4me.530152e8.png";